import type { ColumnDef, FunnelMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn } from '../shared/pivot.js';

export interface FunnelResult {
  labels: string[];
  values: number[];
}

export function prepFunnelSeries(
  rows: Record<string, unknown>[],
  _columnDefs: ColumnDef[],
  mapping: FunnelMapping
): FunnelResult {
  const tableData = rowsToColumnar(rows);
  const rawLabels = getColumn<string>(tableData, mapping.stage).map(String);
  const rawValues = getColumn<number>(tableData, mapping.value).map((v) => Number(v) || 0);
  const paired = rawLabels.map((label, i) => ({ label, value: rawValues[i] ?? 0 }));
  paired.sort((a, b) => b.value - a.value);
  return { labels: paired.map((p) => p.label), values: paired.map((p) => p.value) };
}
